<template>
    <div>
        <el-form label-position="right" ref="form" :model="form.model" :rules="formRules"
                 :validate-on-rule-change="false" label-width="120px">
            <el-row>
                <el-row class="column-name" justify="start">
                    <span>基本信息</span>
                </el-row>
                <el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="编号" prop="code">
                                <el-input v-model="form.model.code" :disabled="!formEditable"
                                          :maxlength="32" placeholder="限32个字符" show-word-limit size="small">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="组名" prop="name">
                                <el-input v-model="form.model.name" :disabled="!formEditable"
                                          :maxlength="60" placeholder="限60个字符" show-word-limit size="small">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24">
                            <el-form-item label="描述" prop="description">
                                <el-input type="textarea" v-model="form.model.description" :disabled="!formEditable"
                                          :maxlength="120" placeholder="限120个字符" show-word-limit size="small">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="状态" prop="status">
                                <el-select v-model="form.model.status" :disabled="true" size="small" class="width100">
                                    <el-option :value="1" :label="'启用'">
                                    </el-option>
                                    <el-option :value="0" :label="'停用'">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-row>
            </el-row>
        </el-form>

        <equipment-group-equipment-panel :group-id="form.model.id"
                                         :addable="form.model.id != null && form.model.status === 1"
                                         v-if="form.model.id != null">
        </equipment-group-equipment-panel>
    </div>
</template>

<script>
    import {
        EVENT_KEY$$DETAILS$$INVALIDATE,
        EVENT_KEY$$DETAILS$$REMOVE,
        EVENT_KEY$$DETAILS$$REVALIDATE,
        EVENT_KEY$$DETAILS$$SAVE_ADD,
        EVENT_KEY$$DETAILS$$SAVE_EDIT,
        EVENT_KEY$$INDEX$$SET_DETAILS_FORM_MODEL,
        EVENT_KEY$$PAGE$$QUERY,
        EVENT_KEY$$PAGE$$REMOVE_VISITED_ID,
        EVENT_KEY$$PAGE$$SET_CURRENT_ROW_ID,
        OPERATION_ADD,
        OPERATION_EDIT,
        OPERATION_SHOW,
        PATH_DETAILS,
        PATH_PAGE,
    } from './common';
    import DcimServer from "@/api/dcim";
    import eventBus from '@/util/common/event-bus';
    import EquipmentGroupEquipmentPanel from './equipment-group-equipment-panel';

    export default {
        name: "equipment-group-details",
        components: {EquipmentGroupEquipmentPanel},
        data() {
            return {
                operation: null,
                form: {
                    model: {
                        code: null,
                        name: null,
                        description: null,
                        status: 1,
                    },
                },

                eventKeyIds: {},
            }
        },
        computed: {
            formRules() {
                return {
                    code: [
                        {required: true, message: '请填写编码', trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: '请填写组名', trigger: 'blur'}
                    ],
                    description: [
                        {required: false, message: '请填写描述', trigger: 'change'}
                    ],
                    status: [
                        {required: true, message: '请选择状态', trigger: 'change'}
                    ],
                };
            },
            formEditable() {
                return (this.operation === OPERATION_ADD || this.operation === OPERATION_EDIT);
            },
        },
        watch: {
            '$route': {
                deep: true,
                immediate: true,
                handler() {
                    let operation = this.$route.query.operation, id = this.$route.query.id;
                    operation = operation == null ? OPERATION_ADD : operation;
                    if (id == null || OPERATION_ADD.endsWith(operation)) {
                        this.toAdd();
                    } else if (OPERATION_SHOW.endsWith(operation)) {
                        this.setCurrentRowId(id);
                        this.toShow(id);
                    } else if (OPERATION_EDIT.endsWith(operation)) {
                        this.setCurrentRowId(id);
                        this.toEdit(id);
                    }
                },
            },
        },
        methods: {
            setFormModel(model) {
                this.form.model = model;
                eventBus.trigger(EVENT_KEY$$INDEX$$SET_DETAILS_FORM_MODEL, model);
            },
            async queryFormModel(id) {
                try {
                    let data = await DcimServer.equipmentGroup.get(id);
                    return Promise.resolve(data);
                } catch (e) {
                    this.$message.error(e);
                }
            },
            async toAdd() {
                this.operation = OPERATION_ADD;
                if (this.$refs.form != null) {
                    this.$refs.form.resetFields();
                }
                this.setFormModel({
                    id: null,
                    code: null,
                    name: null,
                    description: null,
                    status: 1,
                });
            },
            async toShow(id) {
                this.setFormModel(await this.queryFormModel(id));
                this.operation = OPERATION_SHOW;
                return Promise.resolve(this.form.model);
            },
            async toEdit(id) {
                this.setFormModel(await this.queryFormModel(id));
                this.operation = OPERATION_EDIT;
                return Promise.resolve(this.form.model);
            },
            async saveAdd() {
                try {
                    let validated = await this.$refs.form.validate();
                    if (validated) {
                        let data = await DcimServer.equipmentGroup.add(this.form.model);
                        this.$message.success('保存成功！');
                        this.callListQuery();
                        await this.$router.push({
                            path: PATH_DETAILS,
                            query: {operation: OPERATION_SHOW, id: data.id}
                        });
                    }
                } catch (message) {
                    this.$message.error(message);
                }
            },
            async saveEdit() {
                try {
                    let validated = await this.$refs.form.validate();
                    if (validated) {
                        let data = await DcimServer.equipmentGroup.update(this.form.model.id, this.form.model);
                        this.$message.success('保存成功！');
                        this.callListQuery();
                        await this.$router.push({
                            path: PATH_DETAILS,
                            query: {operation: OPERATION_SHOW, id: data.id}
                        });
                    }
                } catch (message) {
                    this.$message.error(message);
                }
            },
            async invalidate() {
                let success = false;
                try {
                    let confirmed = await this.$confirm('确定停用吗？', '停用提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    });
                    if (confirmed) {
                        await DcimServer.equipmentGroup.invalidate(this.form.model.id);
                        success = true;

                    }
                } catch (message) {
                    this.$message.error(`停用失败：${message}`);
                }
                if (success) {
                    this.$message.success('停用成功！');
                    this.toShow(this.form.model.id);
                    this.callListQuery();
                }
            },
            async revalidate() {
                let success = false;
                try {
                    let confirmed = await this.$confirm('确定启用吗？', '启用提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    });
                    if (confirmed) {
                        await DcimServer.equipmentGroup.revalidate(this.form.model.id);
                        success = true;
                    }
                } catch (message) {
                    this.$message.error(`启用失败：${message}`);
                }
                if (success) {
                    this.$message.success('启用成功！');
                    this.toShow(this.form.model.id);
                    this.callListQuery();
                }
            },
            async remove() {
                let confirmed = false;
                confirmed = await this.$confirm('确定删除吗？', '删除提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });
                try {
                    if (confirmed) {
                        await DcimServer.equipmentGroup.delete(this.form.model.id);
                        eventBus.trigger(EVENT_KEY$$PAGE$$REMOVE_VISITED_ID, this.form.model.id);
                        this.callListQuery();
                        this.$message.success('删除成功！');
                        await this.$router.push({path: PATH_PAGE});
                    }
                } catch (message) {
                    this.$message.error(message);
                }
            },
            callListQuery() {
                eventBus.trigger(EVENT_KEY$$PAGE$$QUERY);
            },
            setCurrentRowId(currentRowId) {
                eventBus.trigger(EVENT_KEY$$PAGE$$SET_CURRENT_ROW_ID, currentRowId);
            },
        },
        mounted() {
            this.eventKeyIds[EVENT_KEY$$DETAILS$$SAVE_ADD] =
                eventBus.bind(EVENT_KEY$$DETAILS$$SAVE_ADD, {
                    next: () => {this.saveAdd();}
                });
            this.eventKeyIds[EVENT_KEY$$DETAILS$$SAVE_EDIT] =
                eventBus.bind(EVENT_KEY$$DETAILS$$SAVE_EDIT, {
                    next: () => {this.saveEdit();}
                });
            this.eventKeyIds[EVENT_KEY$$DETAILS$$INVALIDATE] =
                eventBus.bind(EVENT_KEY$$DETAILS$$INVALIDATE, {
                    next: () => {this.invalidate();}
                });
            this.eventKeyIds[EVENT_KEY$$DETAILS$$REVALIDATE] =
                eventBus.bind(EVENT_KEY$$DETAILS$$REVALIDATE, {
                    next: () => {this.revalidate();}
                });
            this.eventKeyIds[EVENT_KEY$$DETAILS$$REMOVE] =
                eventBus.bind(EVENT_KEY$$DETAILS$$REMOVE, {
                    next: () => {this.remove();}
                });
        },
        beforeDestroy() {
            eventBus.unbind(this.eventKeyIds[EVENT_KEY$$DETAILS$$SAVE_ADD]);
            eventBus.unbind(this.eventKeyIds[EVENT_KEY$$DETAILS$$SAVE_EDIT]);
            eventBus.unbind(this.eventKeyIds[EVENT_KEY$$DETAILS$$INVALIDATE]);
            eventBus.unbind(this.eventKeyIds[EVENT_KEY$$DETAILS$$REVALIDATE]);
            eventBus.unbind(this.eventKeyIds[EVENT_KEY$$DETAILS$$REMOVE]);
        },
    }
</script>

<style scoped>

</style>
